import React from "react";
import SaveRowButton from "./SaveRowButton";
import CancelRowButton from "./CancelRowButton";
import EditRowButton from "./EditRowButton";
import DeleteRowButton from "./DeleteRowButton";
import SelectRowButton from "./SelectRowButton";

/**
 * TableActionGroup - Pre-configured button group for table rows
 * 
 * Provides standard Edit/Delete/Select buttons for view mode
 * or Save/Cancel buttons for editing mode
 * 
 * @param {Object} props
 * @param {string} props.mode - Button mode ("view" or "editing")
 * @param {function} props.onSave - Save handler (editing mode)
 * @param {function} props.onCancel - Cancel handler (editing mode)
 * @param {function} props.onEdit - Edit handler (view mode)
 * @param {function} props.onDelete - Delete handler (view mode)
 * @param {function} props.onSelect - Select handler (view mode)
 * @param {boolean} props.showEdit - Show edit button (default: true)
 * @param {boolean} props.showDelete - Show delete button (default: true)
 * @param {boolean} props.showSelect - Show select button (default: false)
 * @param {boolean} props.disableEdit - Disable edit button
 * @param {boolean} props.disableDelete - Disable delete button
 * @param {boolean} props.disableSelect - Disable select button
 * 
 * @example
 * // Editing mode
 * <TableActionGroup
 *   mode="editing"
 *   onSave={handleSave}
 *   onCancel={handleCancel}
 * />
 * 
 * // View mode with all buttons
 * <TableActionGroup
 *   mode="view"
 *   onEdit={handleEdit}
 *   onDelete={handleDelete}
 *   onSelect={handleSelect}
 *   showSelect={true}
 *   disableDelete={hasReferences}
 * />
 */
const TableActionGroup = ({
  mode = "view",
  onSave,
  onCancel,
  onEdit,
  onDelete,
  onSelect,
  showEdit = true,
  showDelete = true,
  showSelect = false,
  disableEdit = false,
  disableDelete = false,
  disableSelect = false,
  loading=false
}) => {
  if (mode === "editing") {
    return (
      <div className="app-action-btns">
        <SaveRowButton onClick={onSave} loading={loading} />
        <CancelRowButton onClick={onCancel} />
      </div>
    );
  }

  return (
    <div className="app-action-btns">
      {showEdit && <EditRowButton onClick={onEdit} disabled={disableEdit} loading={loading} />}
      {showDelete && <DeleteRowButton onClick={onDelete} disabled={disableDelete} />}
      {showSelect && <SelectRowButton onClick={onSelect} disabled={disableSelect} />}
    </div>
  );
};

export default TableActionGroup;

